/**
 * @file Defines the {@link UI_AUTOSPIN_DOM_CONFIG} constant
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

 /**
 * Config for UI DOM structure.
 * @type {ui-dom-config[]}
 * @constant
 */

 const UI_AUTOSPIN_DOM_CONFIG = [

    {

        id: 'autospinContainerMobile',
        element: 'div',
        classList: ['mobileInterface'],
        siblings: [

            {

                id: 'autospin-header',
                element:   'div',
                classList: ['header'],
                siblings: [

                    {

                        id: 'autospin-header-text',
                        element:   'div',
                        classList: ['header-text']

                    }

                ]
                
            },

            {

                id: 'autospin-body',
                element:   'div',
                classList: ['body'],
                siblings: [

                    {

                        id: 'autospin-play',
                        element: 'button',
                        classList: [ 'button', 'interface-close-button' ],
                        siblings: []

                    },

                    {

                        id: 'autospin-close',
                        element: 'button',
                        classList: [ 'button', 'interface-close-button' ]

                    },

                    {

                        id: 'autospin-input',
                        element:   'div',
                        classList: ['input', 'scrollable__content'],
                        siblings: [

                            {

                                id: 'autospin-range-input',
                                element: 'div',
                                classList: ['range-input'],
                                siblings: [

                                    {

                                        id: 'autospin-minus-button',
                                        element: 'div',
                                        classList: ['minus-button'],
                                        siblings: [

                                            {

                                                id: 'autospin-minus',
                                                element:   'button',
                                                classList: ['roundButton', 'minus'],
        
                                            }

                                        ]

                                    },

                                    {

                                        id: 'autospin-amount',
                                        element:   'div',
                                        classList: ['amount']

                                    },


                                    {

                                        id: 'autospin-plus-button',
                                        element: 'div',
                                        classList: ['plus-button'],
                                        siblings: [

                                            {

                                                id: 'autospin-plus',
                                                element:   'button',
                                                classList: ['roundButton', 'plus'],
        
                                            }

                                        ]

                                    }

                                ]

                            },

                            {

                                id: 'autospin-settings',
                                element: 'div',
                                classList: ['scrollable__content'],
                                siblings: [

                                    {
                                
                                        id: 'autospin-title',
                                        element: 'div',
                                        classList: []
        
                                    },
        
                                    {
        
                                        id: 'autospin-settings-list-1',
                                        element: 'ul',
                                        classList: ['autospin-settings-list'],
                                        siblings: [
        
                                            {
                                               
                                                id: 'on-single-win',
                                                element: 'li',
                                                classList: [],
                                                siblings: [

                                                    {

                                                        id: 'on-single-win-col-1',
                                                        element: 'div',
                                                        classList: ['c-1'],
                                                        siblings: [

                                                            {
        
                                                                id: 'on-single-win-label',
                                                                element: 'label',
                                                                classList: ['switch', 'autoplay'],
                                                                siblings: [
                
                                                                    {
                
                                                                        id: 'on-single-win-input',
                                                                        element: 'input',
                                                                        classList: [],
                                                                        attributes: [
                                                                            { 'type': 'checkbox' }
                                                                        ],
                
                                                                    },
                
                                                                    {
                
                                                                        id: 'on-single-win-slider',
                                                                        element: 'div',
                                                                        classList: ['slider', 'round', 'autoplay'],
                
                                                                    }
                
                                                                ]
                
                                                            }

                                                        ]

                                                    },

                                                    {

                                                        id: 'on-single-win-col-2',
                                                        element: 'div',
                                                        classList: ['c-2'],
                                                        siblings: [
                                                            {
        
                                                                id: 'on-single-win-label-name',
                                                                element: 'label',
                                                                classList: ['label-text'],
                
                                                            }
                                                        ]

                                                    },

                                                    {

                                                        id: 'on-single-win-col-3',
                                                        element: 'div',
                                                        classList: ['c-3'],
                                                        siblings: [
                                                            {

                                                                id: 'autoPlayWinLimit-label',
                                                                element: 'label',
                                                                classList: ['cur-sym']

                                                            },
                                                            {
        
                                                                id: 'autoPlayWinLimit-new',
                                                                element: 'div',
                                                                classList: ['settings-input']
                
                                                            }
                                                        ]

                                                    }
        
                                                ]
        
                                            },
        
                                            {
                                               
                                                id: 'if-cash-increase',
                                                element: 'li',
                                                classList: [],
                                                siblings: [

                                                    {

                                                        id: 'if-cash-increase-col-1',
                                                        element: 'div',
                                                        classList: ['c-1'],
                                                        siblings: [

                                                            {
        
                                                                id: 'if-cash-increase-label',
                                                                element: 'label',
                                                                classList: ['switch', 'autoplay'],
                                                                siblings: [
                
                                                                    {
                
                                                                        id: 'if-cash-increase-input',
                                                                        element: 'input',
                                                                        classList: [],
                                                                        attributes: [
                                                                            { 'type': 'checkbox' }
                                                                        ],
                
                                                                    },
                
                                                                    {
                
                                                                        id: 'if-cash-increase-slider',
                                                                        element: 'div',
                                                                        classList: ['slider', 'round', 'autoplay'],
                
                                                                    }
                
                                                                ]
                
                                                            }

                                                        ]

                                                    },

                                                    {

                                                        id: 'if-cash-increase-col-2',
                                                        element: 'div',
                                                        classList: ['c-2'],
                                                        siblings: [

                                                            {
        
                                                                id: 'if-cash-increase-label-name',
                                                                element: 'label',
                                                                classList: ['label-text'],
                
                                                            }

                                                        ]

                                                    },

                                                    {

                                                        id: 'if-cash-increase-col-3',
                                                        element: 'div',
                                                        classList: ['c-3'],
                                                        siblings: [

                                                            {

                                                                id: 'autoPlayCashLimit-label',
                                                                element: 'label',
                                                                classList: ['cur-sym']

                                                            },
                                                            {
        
                                                                id: 'autoPlayCashLimit-new',
                                                                element: 'div',
                                                                classList: ['settings-input']
                
                                                            }

                                                        ]

                                                    }
        
                                                ]
        
                                            },
        
                                            {
                                               
                                                id: 'if-cash-decrease',
                                                element: 'li',
                                                classList: [],
                                                siblings: [

                                                    {

                                                        id: 'if-cash-decrease-col-1',
                                                        element: 'div',
                                                        classList: ['c-1'],
                                                        siblings: [

                                                            {
        
                                                                id: 'if-cash-decrease-label',
                                                                element: 'label',
                                                                classList: ['switch', 'autoplay'],
                                                                siblings: [
                
                                                                    {
                
                                                                        id: 'if-cash-decrease-input',
                                                                        element: 'input',
                                                                        classList: [],
                                                                        attributes: [
                                                                            { 'type': 'checkbox' }
                                                                        ],
                
                                                                    },
                
                                                                    {
                
                                                                        id: 'if-cash-decrease-slider',
                                                                        element: 'div',
                                                                        classList: ['slider', 'round', 'autoplay'],
                
                                                                    }
                
                                                                ]
                
                                                            }

                                                        ]

                                                    },

                                                    {

                                                        id: 'if-cash-decrease-col-2',
                                                        element: 'div',
                                                        classList: ['c-2'],
                                                        siblings: [

                                                            {
        
                                                                id: 'if-cash-decrease-label-name',
                                                                element: 'label',
                                                                classList: ['label-text'],
                
                                                            }

                                                        ]

                                                    },

                                                    {

                                                        id: 'if-cash-decrease-col-3',
                                                        element: 'div',
                                                        classList: ['c-3'],
                                                        siblings: [
                                                            
                                                            {

                                                                id: 'autoPlayCashDownLimit-label',
                                                                element: 'label',
                                                                classList: ['cur-sym']

                                                            },
                                                            {
        
                                                                id: 'autoPlayCashDownLimit-new',
                                                                element: 'div',
                                                                classList: ['settings-input']
                
                                                            }

                                                        ]

                                                    },

                                                    {
                
                                                        id: 'autoPlayCashDownLimit-tooltip',
                                                        element: 'div',
                                                        classList: ['settings-tooltip', 'hidden']
        
                                                    }
        
                                                ]
        
                                            }
        
                                        ]
        
                                    },

                                    {

                                        id: 'autospin-settings-list-2',
                                        element: 'ul',
                                        classList: ['autospin-settings-list'],
                                        siblings: [

                                            {
        
                                                id: 'on-any-win',
                                                element: 'li',
                                                classList: [],
                                                siblings: [

                                                    {

                                                        id: 'on-any-win-col-1',
                                                        element: 'div',
                                                        classList: ['c-1'],
                                                        siblings: [

                                                            {
        
                                                                id: 'on-any-win-label',
                                                                element: 'label',
                                                                classList: ['switch', 'autoplay'],
                                                                siblings: [
                
                                                                    {
                
                                                                        id: 'on-any-win-input',
                                                                        element: 'input',
                                                                        classList: [],
                                                                        attributes: [
                                                                            { 'type': 'checkbox' }
                                                                        ],
                
                                                                    },
                
                                                                    {
                
                                                                        id: 'on-any-win-slider',
                                                                        element: 'div',
                                                                        classList: ['slider', 'round', 'autoplay'],
                
                                                                    }
                
                                                                ]
                
                                                            }

                                                        ]

                                                    },

                                                    {

                                                        id: 'on-any-win-col-2',
                                                        element: 'div',
                                                        classList: ['c-2'],
                                                        siblings: [

                                                            {
        
                                                                id: 'on-any-win-label-name',
                                                                element: 'label',
                                                                classList: ['label-text'],
                
                                                            }

                                                        ]

                                                    }
        
                                                ]
        
                                            },
        
                                            {
        
                                                id: 'on-feature',
                                                element: 'li',
                                                classList: [],
                                                siblings: [

                                                    {

                                                        id: 'on-feature-col-1',
                                                        element: 'div',
                                                        classList: ['c-1'],
                                                        siblings: [

                                                            {
        
                                                                id: 'on-feature-label',
                                                                element: 'label',
                                                                classList: ['switch', 'autoplay'],
                                                                siblings: [
                
                                                                    {
                
                                                                        id: 'on-feature-input',
                                                                        element: 'input',
                                                                        classList: [],
                                                                        attributes: [
                                                                            { 'type': 'checkbox' }
                                                                        ],
                
                                                                    },
                
                                                                    {
                
                                                                        id: 'on-feature-slider',
                                                                        element: 'div',
                                                                        classList: ['slider', 'round', 'autoplay'],
                
                                                                    }
                
                                                                ]
                
                                                            }

                                                        ]

                                                    },

                                                    {

                                                        id: 'on-feature-col-2',
                                                        element: 'div',
                                                        classList: ['c-2'],
                                                        siblings: [

                                                            {
        
                                                                id: 'on-feature-label-name',
                                                                element: 'label',
                                                                classList: ['label-text'],
                
                                                            }

                                                        ]

                                                    }
        
                                                ]
        
                                            }

                                        ]

                                    }

                                ]

                            }

                        ]

                    }

                ]

            }

        ]

    }

 ]

 export { UI_AUTOSPIN_DOM_CONFIG }